import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, BoxProps, Flex, ModalTitle } from '@modusign/design-system';
import { ReactNode } from 'react';

interface FullWidthButtonModalTitleProps extends BoxProps<'div'> {
  children: ReactNode;
  onClose?: () => void;
}

export default function FullWidthButtonModalTitle({
  children,
  onClose,
  ...props
}: FullWidthButtonModalTitleProps) {
  return (
    <Box width="100%" {...props}>
      <Box position="relative">
        <ModalTitle alignItems="center" display="flex" justifyContent="center">
          {children}
        </ModalTitle>
        {onClose && (
          <Flex
            alignContent="center"
            borderRadius={4}
            height="28px"
            justifyContent="center"
            position="absolute"
            right={['-14px', '-28px']}
            sx={{
              '&:hover': {
                backgroundColor: 'buttonBackgroundNeutralSlightlyDark',
              },
            }}
            top="-28px"
            width="28px"
          >
            <Flex
              alignItems="center"
              color="iconNeutralBase"
              display="flex"
              fontSize="large"
              fontWeight="regular"
              justifyContent="center"
              sx={{
                cursor: 'pointer',
              }}
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Flex>
          </Flex>
        )}
      </Box>
    </Box>
  );
}
